import ExtendedDeviceApi from '@api/ExtendedDeviceApi'
import ExtendedEcoScoreApi from '@api/ExtendedEcoScoreApi'
import ExtendedMaintenanceItemApi from '@api/ExtendedMaintenanceItemApi'
import ExtendedNotificationsApi from '@api/ExtendedNotificationsApi'
import ExtendedPilotApi from '@api/ExtendedPilotApi'
import ExtendedQuickActionApi from '@api/ExtendedQuickActionApi'
import ExtendedTagApi from '@api/ExtendedTagApi'
import ExtendedTripApi from '@api/ExtendedTripApi'
import ExtendedVehicleApi from '@api/ExtendedVehicleApi'
import ExtendedTriplogApi from './ExtendedTriplogApi'
import ExtendedZoneApi from '@api/ExtendedZoneApi'
import ExtendedRuleApi from '@api/ExtendedRuleApi'
import ExtendedExportApi from '@api/ExtendedExportApi'
import getBasePath from '@util/path'
import ExtendedHealthApi from '@api/ExtendedHealthApi'
import ExtendedImportApi from '@api/ExtendedImportApi'
import ExtendedDirectedRouteApi from '@api/ExtendedDirectedRouteApi'
import ExtendedFuelStopsApi from './ExtendedFuelStopsApi'
import ExtendedRuleV2Api from '@api/ExtendedRuleV2Api'

let basePath = getBasePath() + '/my-trips'

export function createPilotAPIClient (): ExtendedPilotApi {
  return new ExtendedPilotApi({ basePath })
}

export function createTagAPIClient (): ExtendedTagApi {
  return new ExtendedTagApi({ basePath })
}

export function createMaintenanceItemAPIClient (): ExtendedMaintenanceItemApi {
  return new ExtendedMaintenanceItemApi({ basePath })
}

export function createTripAPIClient (): ExtendedTripApi {
  return new ExtendedTripApi({ basePath })
}

export function createTriplogAPIClient (): ExtendedTriplogApi {
  return new ExtendedTriplogApi({ basePath })
}

export function createVehicleAPIClient (): ExtendedVehicleApi {
  return new ExtendedVehicleApi({ basePath })
}

export function createZoneAPIClient (): ExtendedZoneApi {
  return new ExtendedZoneApi({ basePath })
}

export function createRuleAPIClient (): ExtendedRuleApi {
  return new ExtendedRuleApi({ basePath })
}

export function createRuleV2APIClient (): ExtendedRuleV2Api {
  return new ExtendedRuleV2Api({ basePath })
}

export function createExportAPIClient (): ExtendedExportApi {
  return new ExtendedExportApi({ basePath })
}

export function createHealthAPIClient (): ExtendedHealthApi {
  return new ExtendedHealthApi({ basePath })
}

export function createImportAPIClient (): ExtendedImportApi {
  return new ExtendedImportApi({ basePath })
}

export function createDirectedRouteAPIClient (): ExtendedDirectedRouteApi {
  return new ExtendedDirectedRouteApi({ basePath })
}

export function createFuelStopsAPIClient (): ExtendedFuelStopsApi {
  return new ExtendedFuelStopsApi({ basePath })
}

export function createNotificationsAPIClient (): ExtendedNotificationsApi {
  return new ExtendedNotificationsApi({ basePath })
}

export function createDeviceAPIClient (): ExtendedDeviceApi {
  return new ExtendedDeviceApi({ basePath })
}

export function createQuickActionAPIClient (): ExtendedQuickActionApi {
  return new ExtendedQuickActionApi({ basePath })
}

export function createEcoScoreApiClient (): ExtendedEcoScoreApi {
  return new ExtendedEcoScoreApi({ basePath })
}
